import { Component, OnInit, ViewChild } from "@angular/core";
import * as FileSaver from "file-saver";
import { NgxSpinnerService } from "ngx-spinner";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { Condition } from "src/app/models/custom-types";
import { CartasDTO } from "src/app/models/dto/cartas.dto";
import { FilterEvent } from "src/app/models/filter";
import { ListAction } from "src/app/models/list-actions.model";
import { ListColumn } from "src/app/models/list-columns.model";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { LayoutsService } from "src/app/services/layouts.service";
import { Filter } from "src/app/shared/classes/filter";
import { OperadoresService } from "../../workers/operadores/operadores.service";
import { CartasService } from "./cartas.service";
import { CartasCompromisoForm } from "./form/form.component";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import * as dayjs from "dayjs";

dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
  selector: "app-cartas",
  templateUrl: "./cartas.component.html",
  styleUrls: [],
})
export class CartasComponent implements OnInit {
  columnId: string = "IdEmpresa";
  public columns: ListColumn[] = [
    {
      name: "Folio",
      property: "Folio",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Nombre",
      property: "Nombre",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Fecha",
      property: "FechaCreadoStr",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];

  public actions: ListAction<CartasDTO>[] = [
    {
      desc: "Ver",
      action: "update",
      visible: () => true,
    },
    {
      desc: "Imprimir",
      action: "down",
      visible: () => true,
    },
  ];

  filtro: string = "";
  realdata: CartasDTO[];
  list: any[];

  @ViewChild(CardTableComponent, { static: true })
  public tableComp: CardTableComponent;

  @ViewChild(CartasCompromisoForm, { static: true })
  public formulario: CartasCompromisoForm;
  constructor(
    public service: CartasService,
    public opeServ: OperadoresService,
    public layoutService: LayoutsService,
    public spinner: NgxSpinnerService,
    public alerts: AlertasSwalService
  ) {}
  ngOnInit(): void {
    this.loadRecords();
    this.filter = new Filter<CartasDTO>(this.conditions, this.columns, true);
  }

  loadRecords() {
    this.service.get().subscribe(
      (resultData) => {
        this.realdata = resultData.map((m) => {
                  const date = dayjs.utc(m.FechaCreado);

                  // Convert to GMT -8 (Pacific Time)
                  const gmt8Date = date.tz("America/Los_Angeles");
                  const fechaTransform = m.FechaCreado ? gmt8Date : null;
                  return {
                    ...m,
                    FechaCreadoStr: fechaTransform
                      ? fechaTransform.format("DD/MM/YYYY hh:mm a")
                      : "",
                  };
                });
        this.filter.setDataTable(this.realdata, this.tableComp);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
    this.opeServ.get().subscribe(
      (resultData) => {
        this.list = resultData;
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  //#region Filter

  public filter: Filter<CartasDTO>;
  public conditions: Condition<CartasDTO> = {
    Nombre: (o, f) => o.Nombre.toLocaleLowerCase().indexOf(f) > -1,
    Folio: (o, f) =>
      (o.Folio ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
  };

  filterdata(e: FilterEvent) {
    this.filter.filterdata(e, this.realdata, this.tableComp);
  }

  //#endregion Filter
  actionstable(e: { action: string; row: any }) {
    if (e.action == "update") {
      this.formulario.setUpdate(e.row);
    } else if (e.action == "down") {
      this.downLoad(e.row.IdCartaCompromiso, e.row.Folio);
    }
  }

  saveForm(e: { mode: string; value: any }) {
    if (e.mode == "create") {
      this.guardar(e.value);
    }
  }
  guardar(row: any) {
    this.service.add(row).subscribe(
      (next) => {
        this.alerts.correcta("Carta compromiso creada", "Folio " + next.folio);
        this.formulario.setStanby();
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  downLoad(e, folio) {
    this.spinner.show();
    this.service.getPdf(e).subscribe(
      (response) => {
        const contentType = response.headers.get("content-type");
        this.downLoadFile(
          response.body,
          contentType,
          "carta_compromiso_" + folio + ".pdf"
        );
      },
      (err) => {
        this.spinner.hide();
        this.alerts.error("Error", "Ocurrio un error");
      }
    );
  }
  downLoadFile(data: any, contentType: string, filename: string) {
    let blob = new Blob([data], { type: contentType });
    FileSaver.saveAs(blob, filename);
    this.spinner.hide();
  }
}
